let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bCpfn")).then(() => parcelRequire('SInNv'));